import { useFormContext, useWatch } from "react-hook-form";
import { FontStyles } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormInputWithUnit, FormSelect, FormRangeSlider } from "../../../../components/FormFields";
import styles from "../Shared/CommonFields.module.css";

const HoverEffectOptions = [
    { label: "None", value: "none" },
    { label: "Box Shadow", value: "box_shadow" },
    { label: "Lift (shadow + rise)", value: "lift" },
    { label: "Scale (zoom in)", value: "scale" },
    { label: "Border Highlight", value: "border_highlight" },
    { label: "Pulse Ring", value: "pulse" },
];
const HOVER_EFFECTS_USING_SIZE = ["box_shadow", "lift", "border_highlight"];

const VolumeDesignProductCard = () => {
    const { control } = useFormContext();
    const hoverEffect = useWatch({ control, name: "bundles_design.hover_effect" });
    const showHoverSize = HOVER_EFFECTS_USING_SIZE.includes(hoverEffect);

    return (
        <div>
            <div id="product-card-general">
                <FormSubSection rowLabel={"General"}>
                    <FormColorPicker name="bundles_design.product_background_color" label="Selected Background Color" />
                    <FormColorPicker name="bundles_design.product_border_color" label="Card Border Color" />
                    <FormInputWithUnit
                        name="bundles_design.border_width"
                        min={1}
                        label="Border Width"
                        placeholder="border width"
                        unitSuffix="px"
                    />
                    <FormRangeSlider
                        name="bundles_design.border_radius"
                        min={0}
                        max={60}
                        label="Border Radius"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                </FormSubSection>
            </div>

            <div id="product-card-hover-effect">
                <FormSubSection rowLabel={"Hover Effect"}>
                    <FormSelect
                        name="bundles_design.hover_effect"
                        label="Effect"
                        options={HoverEffectOptions}
                        placeholder="Select effect"
                    />
                    <FormColorPicker name="bundles_design.hover_color" label="Hover Color" />
                    <FormRangeSlider
                        name="bundles_design.hover_intensity"
                        min={0}
                        max={100}
                        label="Intensity"
                        suffixTemplate={(val) => `${val}%`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                    <FormInputWithUnit
                        name="bundles_design.hover_size"
                        min={0}
                        label="Size"
                        placeholder="size"
                        unitSuffix="px"
                        disabled={!showHoverSize}
                    />
                </FormSubSection>
            </div>

            <div id="product-card-name">
                <FormSubSection rowLabel={"Title"}>
                    <FormColorPicker name="bundles_design.product_name_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.product_name_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.product_name_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-price">
                <FormSubSection rowLabel={"Product Price"}>
                    <FormColorPicker name="bundles_design.highlighted_price_tag_color" label="Product Price Color" />
                    <FormInputWithUnit
                        name="bundles_design.highlighted_price_tag_size"
                        min={0}
                        label="Product Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.highlighted_price_tag_style"
                        label="Product Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-compare-at-price">
                <FormSubSection rowLabel={"Compare at Price"}>
                    <FormColorPicker name="bundles_design.product_price_color" label="Compare-at Price Color" />
                    <FormInputWithUnit
                        name="bundles_design.product_price_size"
                        min={0}
                        label="Compare-at Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.product_price_style"
                        label="Compare-at Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-quantity-selector">
                <FormSubSection rowLabel={"Quantity Selector"}>
                    <FormColorPicker name="bundles_design.quantity_selector_bg_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.quantity_selector_border_color" label="Border Color" />
                    <FormInputWithUnit
                        name="bundles_design.quantity_selector_border_width"
                        min={0}
                        label="Border Width"
                        placeholder="border width"
                        unitSuffix="px"
                    />
                    <FormRangeSlider
                        name="bundles_design.quantity_selector_border_radius"
                        min={0}
                        max={100}
                        label="Border Radius"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                    <FormColorPicker name="bundles_design.quantity_selector_text_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.quantity_selector_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.quantity_selector_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-swatches-selector">
                <FormSubSection rowLabel={"Variant Selector"} hideSeparator>
                    <FormColorPicker name="bundles_design.variant_selector_text_color" label="Color" />
                    <FormInputWithUnit
                        name="bundles_design.variant_selector_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.variant_selector_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>
        </div>
    );
};

export default VolumeDesignProductCard;
